/*
  Scroll-driven tear drop for the totl-beta-steps section (mobile homepage
  "Trigger / Collect / Distill"), modelled on the live homepage's tear:

  1. The drop starts on step 1's image: small, grayscale and faint.
  2. As step 1 scrolls up to the drop's riding line (45% down the screen) it
     fades in, growing only a little and staying grayscale.
  3. It rides that line past step 2, then crossfades into step 2's image
     (the red tear stone) just above step 3.
  4. Reaching step 3 (the glass) it shrinks and fades out, landing in it.

  Steps 1 and 2's static images are hidden while this runs (the moving drop
  replaces them); step 3's glass stays. Respects prefers-reduced-motion.

  Smoothness: while riding, the drop holds a fixed spot on screen, so it is
  position: fixed and the browser keeps it still during scrolling (a scroll-
  linked transform on an in-page element lags the compositor's scroll on
  phones and jitters). Before the ride it sits on step 1 as an in-page
  element, which scrolls natively. The riding line uses a viewport height
  that ignores the mobile browser toolbar showing and hiding.
*/
(function () {
  function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function smooth(edge0, edge1, value) {
    var t = clamp((value - edge0) / (edge1 - edge0), 0, 1);
    return t * t * (3 - 2 * t);
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    if (section.dataset.tbDropBound === 'true') return;
    section.dataset.tbDropBound = 'true';
    if (reduceMotion) return;

    var drop = section.querySelector('[data-tb-drop]');
    var colorImg = section.querySelector('[data-tb-drop-color]');
    var stoneImg = section.querySelector('[data-tb-drop-stone]');
    var media = [1, 2, 3].map(function (i) {
      return section.querySelector('[data-tb-step-media="' + i + '"]');
    });
    if (!drop || !colorImg || !stoneImg || media.indexOf(null) !== -1) return;

    section.classList.add('is-drop-animated');

    // Centre and size of a step's image, relative to the section.
    function measure(el, sectionRect) {
      var target = el.querySelector('img') || el;
      var rect = target.getBoundingClientRect();
      return {
        x: rect.left - sectionRect.left + rect.width / 2,
        y: rect.top - sectionRect.top + rect.height / 2,
        top: rect.top - sectionRect.top,
        w: rect.width,
        h: rect.height
      };
    }

    // Viewport height for the riding line. document.documentElement.clientHeight
    // stays put while the mobile toolbar shows/hides (innerHeight does not), so
    // the line - and the drop - doesn't jump mid-scroll.
    var viewportHeight = 1;
    function measureViewport() {
      viewportHeight = document.documentElement.clientHeight || window.innerHeight || 1;
    }
    measureViewport();

    var lastWidth = '';
    var lastHeight = '';
    var lastPosition = '';

    function update() {
      // The section is hidden on desktop (Show on: Mobile only).
      if (section.offsetParent === null) {
        drop.style.opacity = '0';
        return;
      }

      var sectionRect = section.getBoundingClientRect();
      var first = measure(media[0], sectionRect);
      var glass = measure(media[2], sectionRect);
      if (!first.w || !glass.h) return;

      var dropWidth = first.w;
      var dropHeight = first.h;
      var startY = first.y;
      var endY = glass.top + glass.h * 0.55; // lands inside the glass
      var travel = Math.max(1, endY - startY);

      // Section-relative position of the drop's riding line on screen.
      var anchor = viewportHeight * 0.45;
      var lineY = anchor - sectionRect.top;

      // Approach (0 -> 1) while step 1 rises from the bottom of the screen to
      // the riding line; travel (0 -> 1) while the drop rides down to the glass.
      var approach = clamp((lineY - (startY - anchor)) / anchor, 0, 1);
      var t = clamp((lineY - startY) / travel, 0, 1);

      var y = startY + travel * t;
      var x = lerp(first.x, glass.x, t);

      // Gray drop: small, and only grows a little on the way in.
      var grow = smooth(0, 1, approach);
      var scale = lerp(0.42, 0.6, grow);
      // Red tear stone: takes over between steps 2 and 3, finishing just
      // above step 3 (step 2's image is at t ~0.5, step 3 starts at ~0.92).
      var toStone = smooth(0.62, 0.84, t);
      scale = lerp(scale, 0.7, smooth(0.62, 0.86, t));
      var landing = smooth(0.86, 1, t);
      scale = lerp(scale, 0.38, landing);

      var opacity = lerp(0.25, 1, grow) * (1 - smooth(0.9, 1, t));
      if (t >= 1) opacity = 0;

      // Size only changes on resize/image load; skip the write (and the layout
      // it triggers) on ordinary scroll frames.
      var width = dropWidth + 'px';
      var height = dropHeight + 'px';
      if (width !== lastWidth) { drop.style.width = width; lastWidth = width; }
      if (height !== lastHeight) { drop.style.height = height; lastHeight = height; }

      // Riding: pinned to the screen at the riding line. Otherwise: placed in
      // the section (on step 1 before the ride, in the glass after it).
      var riding = t > 0 && t < 1;
      var position = riding ? 'fixed' : 'absolute';
      if (position !== lastPosition) { drop.style.position = position; lastPosition = position; }
      var left = riding ? sectionRect.left + x : x;
      var top = riding ? anchor : y;

      drop.style.transform = 'translate3d(' + (left - dropWidth / 2).toFixed(2) + 'px, ' + (top - dropHeight / 2).toFixed(2) + 'px, 0) scale(' + scale.toFixed(3) + ')';
      drop.style.opacity = opacity.toFixed(3);
      colorImg.style.opacity = (1 - toStone).toFixed(3);
      stoneImg.style.opacity = toStone.toFixed(3);
    }

    var ticking = false;
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', function () {
      measureViewport();
      requestUpdate();
    });
    section.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', requestUpdate, { once: true });
    });
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-tb-steps-drop]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-initialise when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', initAll);
})();
